import {
  Button,
  Dialog,
  Backdrop,
  DialogTitle,
  DialogActions,
  DialogContent,
  CircularProgress,
  DialogContentText,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import apiService from 'library/api-service';
import { FormattedMessage, useIntl } from 'react-intl';
import { Dispatch, SetStateAction, useState } from 'react';
import loaderLogoSrc from 'assets/images/idecon-loader-logo.png';
import { GridRowSelectionModel } from '@mui/x-data-grid-premium';

type DeleteEffortRequestDialogProps = {
  open: boolean;
  effortIds: GridRowSelectionModel;
  handleClose: () => void;
  refresh: () => Promise<void>;
  setRowSelectionModel: Dispatch<SetStateAction<GridRowSelectionModel>>;
};

const DeleteEffortRequestDialog = ({
  open,
  effortIds,
  handleClose,
  refresh,
  setRowSelectionModel,
}: DeleteEffortRequestDialogProps) => {
  // other hooks
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    const postData = effortIds.map((effortId) => Number(effortId));

    try {
      setLoading(true);

      const response = await apiService.deleteEffortRequest(postData);

      if (response.isSuccess) {
        enqueueSnackbar(
          intl.formatMessage(
            {
              id: 'effortTracing.deleteEffortRequestCompleted',
              defaultMessage: '{count} adet seçili efor talebi silme işlemi başarıyla tamamlandı.',
            },
            { count: postData.length }
          ),
          { variant: 'success' }
        );
        handleClose();
        setRowSelectionModel([]);
        refresh();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <FormattedMessage id="effortTracing.deleteEffortRequest" defaultMessage="Efor Talebi Sil" />
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <DialogContentText>
          {intl.formatMessage(
            {
              id: 'effortTracing.deleteEffortRequestRepeat',
              defaultMessage:
                'Bu işlem onaylandıktan sonra {count} adet efor talebi veritabanından silinecektir. Silme işlemini onaylıyor musunuz?',
            },
            { count: effortIds.length }
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={handleClose}>
          <FormattedMessage id="forgotPassword.cancel" defaultMessage="Vazgeç" />
        </Button>
        <Button variant="contained" type="button" onClick={handleDelete}>
          <FormattedMessage id="forgotPassword.continue" defaultMessage="Devam" />
        </Button>
      </DialogActions>
      <Backdrop
        sx={{ display: 'flex', flexDirection: 'column', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}>
        <img src={loaderLogoSrc} alt="loader-logo" />
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};

export default DeleteEffortRequestDialog;
